// Klein "logo'tje" naast een boeking dat aangeeft via welk kanaal die
// binnenkwam (Airbnb / Booking.com / Vrbo) - herbruikt in zowel de echte
// kalenders (PropertyTimeline.js, PropertyCalendar.js, AutomationOverview.js)
// als de demo-versies ervan, zodat beide er identiek uitzien. Ook boekingen
// die via Guesty/Hospitable binnenkomen krijgen dit logo: backend/index.js
// detecteert daar (via "bookingSource") het onderliggende kanaal uit de
// iCal-feed en die waarde krijgt hier gewoon voorrang op het kale "platform"-
// label (zie displayPlatform in PropertyTimeline.js/PropertyCalendar.js).
//
// De effectieve merklogo's (PNG, met transparante achtergrond) staan in
// frontend/public/ (Airbnb_logo.png, booking_logo.png, vrbo_logo.png) en
// worden hier louter ter identificatie getoond - net zoals andere channel-
// manager-dashboards (Guesty, Hostaway, ...) naast een reservering ook het
// echte logo van het boekingskanaal tonen.
import './PlatformBadge.css';

// "Direct" (rechtstreekse boeking, geen extern kanaal) heeft bewust geen
// entry hier - die heeft geen logo, dus tonen we daar geen badge voor.
const PLATFORM_ICONS = {
  airbnb: { name: 'Airbnb', imgSrc: '/Airbnb_logo.png' },
  booking: { name: 'Booking.com', imgSrc: '/booking_logo.png' },
  vrbo: { name: 'Vrbo', imgSrc: '/vrbo_logo.png' },
  guesty: { name: 'Guesty', imgSrc: '/Guesty_logo.jpg' },
  sheets: { name: 'Google Sheets', imgSrc: '/google_sheets_logo.svg' },
};

// Normaliseert de uiteenlopende ruwe waarden die "platform"/"bookingSource"
// in de praktijk kunnen bevatten (bv. "AIRBNB", "airbnb", "booking_com",
// "BOOKING", "Booking.com", "vrbo", "HomeAway" - Vrbo's oude naam) naar één
// van de bovenstaande keys. Onbekende/niet-herkenbare waarden (bv. "direct"
// of "GUESTY"/"HOSPITABLE" als er geen onderliggend kanaal gedetecteerd kon
// worden) leveren null op - dan tonen we bewust geen badge i.p.v. een
// onterecht logo.
export function normalizePlatform(raw) {
  if (!raw) return null;
  const key = String(raw).toLowerCase();
  if (key.includes('airbnb')) return 'airbnb';
  if (key.includes('booking')) return 'booking';
  if (key.includes('vrbo') || key.includes('homeaway')) return 'vrbo';
  if (key.includes('guesty')) return 'guesty';
  if (key.includes('sheet')) return 'sheets';
  return null;
}

// Zelfde opzoeking als de React-badge hieronder, maar als kale data (geen
// JSX) - nodig voor FullCalendar (PropertyCalendar.js), dat events niet als
// React rendert maar als losse DOM-nodes via "eventDidMount", waar we het
// badge-elementje zelf moeten opbouwen.
export function getPlatformBadgeStyle(raw) {
  const key = normalizePlatform(raw);
  return key ? PLATFORM_ICONS[key] : null;
}

function PlatformBadge({ platform, className = '' }) {
  const key = normalizePlatform(platform);
  if (!key) return null;
  const icon = PLATFORM_ICONS[key];
  return (
    <span className={`platform-badge platform-badge-${key} ${className}`} title={icon.name}>
      <img src={icon.imgSrc} alt={icon.name} />
    </span>
  );
}

export default PlatformBadge;
